export default __webpack_public_path__ + "adb3e2ead735474452eaa4a01998902b.svg";